import { Form , Input, Button , Select , Typography , Layout, Row, Col, message , Modal , Tooltip  } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import React, { useEffect, useState }  from 'react';
import { useDispatch } from 'react-redux';
import { isValid  } from '../../utils/utilities';
import { showConfirm } from './../custom-components/custom-component';
import './vechicle-management.style.scss';
import {createVechicle , deleteVechicle } from '../../actions/vechicle-actions';
import { postCall } from '../../utils/network.util';
import { SEND_SENSEL_INTEGRATION_URL } from '../../utils/api-url';
import { loadingAction } from '../../actions/loading-actions';
import { getSeatLayOut } from '../../actions/admin.action';
import { SeatLayoutContainer } from '../seat-layout/seat-layout-container.component';

const { Option } = Select;

const { Content, Footer } = Layout;
const { Title, Text } = Typography;

export const  VechicleManagementForm = (props) => {

  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const{
    formData,
    updateFormData,
    busesData,
    fetchVechicles,
    vehicles
  } = {...props};

  const onSuccess=()=>{
    fetchVechicles();
    onReset();
  }
  
  const onReset = () => {
    updateFormData({});
  };

  const [busesOptions, setBusesOptions] = useState([]);

  const [selectedBusId, setSelectedBusId] = useState(null);
  const [seatLayoutModalOpen, setSeatLayoutModalOpen] = useState(false);
  const [seatLayoutData, setSeatLayoutData] = useState([]);

  const [senselModalOpen, setSenselModalOpen] = useState(false);
  const [senselToAddress, setSenselToAddress] = useState('');
  const [senselCcAddress, setSenselCcAddress] = useState('');
  const [senselSending, setSenselSending] = useState(false);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const parseEmailList = (emails) => {
    if(!isValid(emails)) return [];
    return emails
      .toString()
      .split(/[;,]/)
      .map((e) => e.trim())
      .filter((e) => e.length > 0);
  };

  const isValidEmailList = (emails, required=false) => {
    const list = parseEmailList(emails);
    if(required && list.length === 0) return false;
    if(!required && list.length === 0) return true;
    return list.every((e) => emailRegex.test(e));
  };


  const openSeatLayout = () => {
    if(!isValid(selectedBusId)){
      message.info('Please select a bus description');
      return;
    }
    getSeatLayOut(selectedBusId, (data) => {
      const layout = isValid(data) && isValid(data.seat_layout) ? data.seat_layout : [];
      if(layout.length === 0){
        message.info('No seat layout available for this bus');
        return;
      }
      setSeatLayoutData(layout);
      setSeatLayoutModalOpen(true);
    }, () => {
      message.error('Failed to fetch seat layout');
    });
  };

  const findConflictingLayouts = (vechicleNo, busId) => {
    if(!isValid(vechicleNo) || !isValid(vehicles)) return [];
    const normalized = vechicleNo.toString().trim().toLowerCase();
    const busesById = {};
    (busesData || []).forEach((bus) => { busesById[bus.id] = bus; });
    return vehicles.filter((v) => {
      if(!isValid(v?.vechicle_no)) return false;
      const sameNo = v.vechicle_no.toString().trim().toLowerCase() === normalized;
      const differentLayout = v.bus_id !== busId;
      const notCurrentRecord = !isValid(formData?.id) || v.id !== formData.id;
      return sameNo && differentLayout && notCurrentRecord;
    }).map((v) => busesById[v.bus_id]?.description || `Bus ID ${v.bus_id}`);
  };

  const handleSubmit = (e,buttonType) => {
      e.preventDefault();
      form.validateFields()
      .then(values => {
        const conflictingLayouts = findConflictingLayouts(values.vechicle_no, values.bus_id);
        if(conflictingLayouts.length > 0){
          Modal.confirm({
            title: 'Duplicate Vehicle Number',
            content: `Vehicle number "${values.vechicle_no}" is already assigned to another seat layout (${conflictingLayouts.join(', ')}). Do you want to continue?`,
            okText: 'Continue',
            okType: 'default',
            cancelText: 'Cancel',
            onOk() { createVechicle({...values},onSuccess); }
          });
          return;
        }
        dispatch(createVechicle({...values},onSuccess));
      })
      .catch(errorInfo => {
        console.log({errorInfo});
      })
  };


  useEffect(()=>{
      fillForm()
  },[formData])

  useEffect(()=>{
    let tempBusesOptions = [];
    busesData.map((bus)=>{
      tempBusesOptions.push({value: bus.id, label: bus.description});
    })
    setBusesOptions(tempBusesOptions);
  },[busesData]);

  const fillForm=()=>{
      if(isValid(formData)){
        let {
          bus_id,
          vechicle_no
        }=formData;
          form.setFieldsValue({
            bus_id: bus_id,
            vechicle_no: vechicle_no
          })
          setSelectedBusId(isValid(bus_id)?bus_id:null);
      }else{
        setSelectedBusId(null);
        onReset();
      }
  }

  const deleteAction=()=>{
    showConfirm(
      ()=>{
          dispatch(deleteVechicle(formData.id,onSuccess));
      },
      'Delete Vechicle',
      'Are you sure you want to delete this vechicle?'
    );
  }

  let isRowClicked = isValid(formData)&&isValid(formData.id)?true:false;
  const isSenselIntegrationEnabled = isRowClicked && isValid(formData?.vechicle_no);

  const printOption = (option) => {
    return <Option key = {option.id} value={option.id} data={option}>{option.description}</Option>
  };

  return (
    <Layout>
    <Title level={4}>Vehicle Management Form</Title>
      <Content style={{ margin:'10px'}} className='vechicle-content'>
        <Form 
          className="form"
          form={form} 
          name="basic"
          initialValues={{ }}
        >
          <Row>
            <Form.Item
              label="Vechicle No"
              name="vechicle_no"
              rules={[{ required: true, message: 'Please input your name!' }]}
            >
              <Input 
                placeholder="Vechicle No"
              />
            </Form.Item>
            <Form.Item
              label="Bus description"
              name="bus_id"
              rules={[{ required: true, message: 'Please input your type!' }]}
            >
              <Select
                showSearch
                style={{ width: 200 }}
                placeholder="Select bus"
                options={busesOptions}
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                onChange={(value)=>{
                  setSelectedBusId(isValid(value)?value:null);
                }}
              />
            </Form.Item>
            <Tooltip title={isValid(selectedBusId)?"View Seat Layout":"Select a bus to view seat layout"}>
              <EyeOutlined
                className="view-seat-layout-icon"
                style={{
                  color: isValid(selectedBusId)?'#c99a2e':'#bfbfbf',
                  cursor: isValid(selectedBusId)?'pointer':'not-allowed'
                }}
                onClick={()=>{
                  if(!isValid(selectedBusId)) return;
                  openSeatLayout();
                }}
              />
            </Tooltip>
          </Row>
        </Form>
      </Content>
      <Footer style={{ textAlign: 'center' }} type="flex">
      <Row type="flex" justify="space-around">
          <Button
            style={{margin:'5px',background:'#2EC17C'}}
            disabled={isRowClicked}
            onClick={(e)=>{
            handleSubmit(e);
            }}
          >
            <Text>Add</Text>
          </Button>
          <Button type="danger"
            style={{margin:'5px'}}
            disabled={!isRowClicked}
            onClick={deleteAction}
          >
            Delete
          </Button>
          <Button
            type="primary"
            style={{margin:'5px'}}
            disabled={!isSenselIntegrationEnabled}
            onClick={()=>{
              setSenselToAddress('');
              setSenselCcAddress('');
              setSenselModalOpen(true);
            }}
          >
            Sensel Integration
          </Button>
          <Button type="block"
            style={{margin:'5px'}}
            onClick={()=>{
              updateFormData({});
            }}
          >
            Clear
          </Button>
        </Row>
      </Footer>

      <Modal
        title="Seat Layout"
        visible={seatLayoutModalOpen}
        onCancel={() => setSeatLayoutModalOpen(false)}
        footer={null}
        width="95%"
        style={{ maxWidth: 900 }}
        destroyOnClose={true}
      >
        <div style={{ display: 'flex', justifyContent: 'center', overflowX: 'auto' }}>
          <SeatLayoutContainer
            key={selectedBusId}
            seatsData={seatLayoutData}
            showLegend={false}
            showFarePopOver={false}
            blockedSeatAllowed={false}
            noOfSeatsAllowedToClick={0}
            isDragDropRequired={false}
          />
        </div>
      </Modal>

      <Modal
        title="Sensel Integration Request"
        visible={senselModalOpen}
        onCancel={() => setSenselModalOpen(false)}
        footer={null}
        destroyOnClose={true}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Input
              value={senselToAddress}
              onChange={(e) => setSenselToAddress(e.target.value)}
              placeholder="To address (required)"
            />
          </Col>
          <Col span={24}>
            <Input
              value={senselCcAddress}
              onChange={(e) => setSenselCcAddress(e.target.value)}
              placeholder="CC address (optional, supports comma/semicolon)"
            />
          </Col>
        </Row>
        <Row type="flex" justify="end" style={{ marginTop: 16 }}>
          <Button style={{ marginRight: 8 }} onClick={() => setSenselModalOpen(false)}>
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={() => {
              if(!isValidEmailList(senselToAddress, true)){
                message.error('Please enter a valid To address');
                return;
              }
              if(!isValidEmailList(senselCcAddress, false)){
                message.error('Please enter valid CC address(es)');
                return;
              }

              setSenselSending(true);
              dispatch(loadingAction(true));
              postCall(SEND_SENSEL_INTEGRATION_URL, {
                vehicleNumber: formData?.vechicle_no,
                vechicle_no: formData?.vechicle_no,
                toAddress: senselToAddress,
                ccAddress: senselCcAddress
              })
                .then((response) => {
                  if (response?.payload?.Status === 'SUCCESS') {
                    message.success(response?.payload?.Message || 'Sensel integration request sent');
                    setSenselModalOpen(false);
                  } else {
                    message.error(response?.payload?.Message || 'Failed to send sensel integration request');
                  }
                  setSenselSending(false);
                  dispatch(loadingAction(false));
                })
                .catch(() => {
                  message.error('Failed to send sensel integration request');
                  setSenselSending(false);
                  dispatch(loadingAction(false));
                });
            }}
            loading={senselSending}
          >
            Send
          </Button>
        </Row>
      </Modal>
    </Layout>
  );
}
